// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__Xf2dB","actionButtons":"styles_actionButtons__Ybq0R"};